


















import { Bar } from 'vue-chartjs/legacy';
import { ReportSpecByWeek } from '@/components/ReportControls.vue';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiAutorenew } from '@mdi/js';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  LinearScale,
  CategoryScale,
  registerables,
} from 'chart.js';
import axios from 'axios';
import Vue from 'vue';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  LinearScale,
  CategoryScale,
  ChartDataLabels,
  ...registerables,
  );

export default Vue.extend({
  name: 'DailyBillingUnitChartTile',
  components: {
    Bar,
    SvgIcon,
  },
  props: {
    chartId: {
      type: String,
      default: 'barChart',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    width: {
      type: Number,
      default: 800,
    },
    height: {
      type: Number,
      default: 400,
    },
    plugins: {
      type: Array,
      default: () => [],
    },
    spec: Object as () => ReportSpecByWeek,
  },
  data() {
    return {
      path: mdiAutorenew,
      size: 48,
      loading: true,
      chartData: {
        labels: [
          '08:00',
          '09:00',
          '10:00',
          '11:00',
          '12:00',
          '13:00',
          '14:00',
          '15:00',
          '16:00',
          '17:00',
          '18:00',
          '19:00',
          '20:00',
          '21:00',
        ],
        datasets: [
          {
            label: 'Overall Total',
            backgroundColor: '#0B234E',
            pointHitRadius: 15,
            order: 1,
            barPercentage: 1.1,
            data: {},
            datalabels: {
              anchor: 'end',
              align: 'top',
              textAlign: 'center',
              offset: 0,
              clamp: true,
              backgroundColor: '#0B234E',
              borderColor: '#82BD53',
              borderWidth: 1,
              color: 'white',
              borderRadius: 4,
              padding: {
                top: 2,
                bottom: 1,
                left: 3,
                right: 4,
              },
              font: {
                size: 10,
              },
              formatter: (value: any, context: any) => {
                return parseInt(context.dataset.data[context.dataIndex].y, 10).toLocaleString();
              },
            },
          },
          {
            label: '# Added Per Hour',
            backgroundColor: '#82BD53',
            pointHitRadius: 15,
            order: 2,
            barPercentage: 1.1,
            data: {},
            datalabels: {
              anchor: 'start',
              align: 'bottom',
              textAlign: 'center',
              offset: 2,
              backgroundColor: '#0B234E',
              borderColor: '#82BD53',
              borderWidth: 1,
              color: 'white',
              borderRadius: 4,
              padding: {
                top: 2,
                bottom: 1,
                left: 3,
                right: 4,
              },
              font: {
                size: 10,
              },
              formatter: (value: any, context: any) => {
                const formattedNumber = parseInt(context.dataset.data[context.dataIndex].y, 10).toLocaleString();
                return `+${formattedNumber}`;
              },
            },
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: 30,
            bottom: 10,
            left: 0,
            right: 5,
          },
        },
        scales: {
          x: {
            stacked: true,
            title: {
              display: false,
              text: 'Time',
            },
            ticks: {
              padding: 10,
              font: {
                size: 10,
              },
            },
          },
          y: {
            stacked: true,
            title: {
              display: false,
              text: 'Billing Units',
            },
            ticks: {
              display: false,
              beginAtZero: true,
              font: {
                size: 10,
              },
            },
          },
        },
        plugins: {
          legend: {
            position: 'bottom',
            align: 'center',
            labels: {
              padding: 10,
              font: {
                size: 10,
              },
            },
          },
          tooltip: {
            backgroundColor: '#0B234E',
            borderColor: 'rgba(130, 189, 83, 80)',
            borderWidth: 1,
            caretPadding: 10,
            xAlign: 'top',
            yAlign: 'center',
            position: 'nearest',
            padding: {
              top: 10,
              bottom: 10,
              left: 10,
              right: 10,
            },
            titleFont: {
              size: 12,
            },
            footerFont: {
              size: 11,
            },
            callbacks: {
              title: (context: any) => {
                const titleText: string = context[0].datasetIndex === 0
                  ? `Total Billing Units: ${context[0].formattedValue}`
                  : `Added Per Hour: ${context[0].formattedValue}`;
                return titleText;
              },
              label: () => '', // Empty to allow for title + footer combo without default label getting inserted
              footer: (context: any) => {
                const custInfo: Array<{name: string, added: Date, total: number}> = context[0].raw.info;
                const custList = custInfo.map((item) => [item.name,
                  item.added, item.total]);
                custList.sort((item1: any, item2: any) => item2[1] - item1[1]);
                const formattedList: string[] = [];
                custList.forEach((item: any) => {
                  const fItem1 = parseInt(item[1], 10).toLocaleString();
                  const fItem2 = parseInt(item[2], 10).toLocaleString();
                  formattedList.push(`${item[0]} (+${fItem1}) : ${fItem2}`);
                });
                return formattedList.slice(0, 20);
              },
            },
          },
        },
      },
    };
  },
  computed: {
    dataUrl(): string {
      const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
      const { depot, from, to, weekday_from, weekday_to } = this.spec;
      return `${BASE_URL}/reports/daily-billing-unit-report/${depot}/${from.year}/${from.week}/${to.year}/${to.week}/${weekday_from}/${weekday_to}/`;
    },
  },
  watch: {
    spec: {
      immediate: true,
      async handler() {
        const response = await axios.get<{ sectionTotal: { [time: string]: { [item: string]: number } },
          runningTotal: { [time: string]: { [item: string]: number } },
        }>(this.dataUrl, { params: { account_codes: this.spec.accountCodes.flatMap((a: any) => a.codes),
        }});
        this.chartData.datasets[1].data = this.chartData.labels.map((time: string) => ({
          x: time,
          y: response.data.sectionTotal[time].value,
          info: response.data.sectionTotal[time].customers,
        }));
        this.chartData.datasets[0].data = this.chartData.labels.map((time: string) => ({
          x: time,
          y: response.data.runningTotal[time].value,
          info: response.data.runningTotal[time].customers,
        }));
        this.loading = false;
      },
    },
  },
});
